import React, { useEffect, useState } from "react";
import api from "../api";
import { toast } from "react-toastify";

const VendorDashboardPage = () => {
  const [redemptions, setRedemptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    // 1. Get current user from local storage
    const storedUser = localStorage.getItem("currentUser");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      setCurrentUser(user);

      // Check for 'id' OR 'userId'
      const vendorId = user.id || user.userId;

      if (vendorId) {
        fetchDashboardData(vendorId);
      } else {
        console.error("❌ Vendor ID is missing in currentUser object:", user);
        toast.error("Error: Vendor ID not found. Please log out and log in again.");
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, []);

  const fetchDashboardData = async (vendorId) => {
    try {
      const response = await api.get(`/vres/redemption/vendor/${vendorId}/dashboard`);
      setRedemptions(response.data || []);
    } catch (error) {
      console.error("Error fetching vendor dashboard:", error);
      toast.error("Failed to load dashboard data.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-4">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard-container" style={{ padding: "20px" }}>
      <h2 className="mb-4">
        Vendor Dashboard
        {currentUser && (
          <span style={{ fontSize: '0.7em', color: '#6c757d', marginLeft: '10px' }}>
             - {currentUser.name}
          </span>
        )}
      </h2>
      
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white">
            <h5 className="mb-0">Redeemed Vouchers History ({redemptions.length})</h5>
        </div>
        <div className="card-body p-0">
            {redemptions.length === 0 ? (
                <div className="p-4 text-center text-muted">
                    No vouchers have been redeemed by you yet.
                </div>
            ) : (
                <div className="table-responsive">
                    <table className="table table-hover mb-0">
                        <thead className="thead-light">
                            <tr>
                                <th>Redeemed Date</th>
                                <th>Beneficiary Name</th>
                                {/* ✅ REMOVED: Beneficiary ID Column */}
                                <th>Project</th>
                                <th>Voucher Points</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {redemptions.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.redeemedDate}</td>
                                    <td>{item.beneficiaryName}</td>
                                    {/* ✅ REMOVED: Beneficiary ID Data */}
                                    <td>{item.projectTitle}</td>
                                    <td>
                                        <span className="badge bg-success" style={{ fontSize: '0.9em' }}>
                                            {item.voucherPoints}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="badge bg-info text-dark">
                                            {item.status}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default VendorDashboardPage;